export default __webpack_public_path__ + "static/media/KOD0030-min.5d06f9ff.webp";